import { treaty } from "@elysiajs/eden";
// Type-only import: no server code or secrets reach the client bundle (PRD ADR-07).
import type { App } from "@kopi/api";

export function createApiClient(baseUrl: string) {
  return treaty<App>(baseUrl, { fetch: { credentials: "include" } });
}

export type ApiClient = ReturnType<typeof createApiClient>;
